<template>
  <div>
    <dl class="radius5 mb24 relative chapterBox" v-for="(item, index) in list" :key="index">
      <dt class="b500 size18 Conhover Title" @click="item.open = !item.open">
        第{{ index + 1 }}章 {{ item.CatalogName }}
        <i class="el-icon-arrow-up bold" v-if="item.open"></i>
        <i class="el-icon-arrow-down bold" v-else></i>
      </dt>
      <dd v-if="item.open" class="part06">
        <li class="mb1 radius5 BGwhite flex between nowrap chapter-item" v-for="(ch, chIndex) in item.Chapters"
          :key="chIndex" @click.stop="toChapterDetail(ch, list, index, chIndex)">
          <div class="flex1">
            <p class="b500 size16 mb4">
              <span style="margin-right: 10px;">
                第{{ chIndex + 1 }}节
              </span>
              <img :src="(data.IsBuyed || ch.IsFree == true || data.Price == 0) && isUnlocked(list, index, chIndex)
                ? require('@/assets/img/home/21.png')
                : require('@/assets/img/home/22.png')
                " :class="(data.IsBuyed || ch.IsFree == true || data.Price == 0) && isUnlocked(list, index, chIndex)
                  ? 'IsFreeImg'
                  : 'notFreeImg'
                  " alt="" />
              <span class="ChapterName"> {{ ch.ChapterName }}</span>
              <span v-if="ch.IsFree" class="IsFree">免费试看</span>
            </p>

            <p v-if="ch.Duration != '00:00:00'" class="time">
              <el-progress class="width140px mr40 nowrap" :stroke-width="10" :percentage="ch.StudyProgress"
                text-color="#376FF6"></el-progress>
              <span class="timeImg"></span>
              <span class="timeText"> {{ ch.Duration }}</span>
            </p>
          </div>
        </li>
      </dd>
    </dl>
    <el-empty description="暂无内容" :image="empty1" v-if="list.length == 0" />
    <div v-if="JSON.stringify(coursePaper) !== '{}'">
      <div :style="{ background: studyProgress >= 100 ? '' : '#f5f5f5' }" class="coursePaper ISOK">
        <div class="coursePaper-left">
          <img src="@/assets/img/home/27.png" alt="" />
          <div>
            <p class="PaperName">{{ coursePaper.PaperName || "-" }}</p>
            <p class="PaperContent">
              <span class="mr30">题量：{{ coursePaper.TotalNum }}</span>
              <span class="mr30">时长： {{ coursePaper.Duration }}分钟</span>
              <span class="mr30">总分：{{ coursePaper.TotalScore }}分</span>
              <span v-if="coursePaper.StatusID == 2" class="mr30">考试得分：{{ coursePaper.GetScore }}分</span>
              <span v-if="coursePaper.StatusID == 2" class="mr30">{{
                coursePaper.IsPass == true ? "合格" : "不合格"
                }}</span>
            </p>
          </div>
        </div>
        <div class="coursePaper-right" @click="toExam">
          <img src="@/assets/img/home/28.png" alt="" /> 考试
        </div>
      </div>

      <!-- <div v-else class="coursePaper">
        <div class="coursePaper-left">
          <img src="@/assets/img/home/26.png" alt="" />
          <div>
            <p class="PaperName">{{ coursePaper.PaperName || "-" }}</p>
            <p class="PaperContent">
              <span class="mr30">题量：{{ coursePaper.TotalNum }}</span>
              <span class="mr30">时长： {{ coursePaper.Duration }}分钟</span>
              <span class="mr30">及格分：{{ coursePaper.PassScore }}分</span>
              <span class="mr30">总分：{{ coursePaper.TotalScore }}分</span>
              <span v-if="coursePaper.StatusID == 2" class="mr30"
                >考试得分：{{ coursePaper.GetScore }}分</span
              >
              <span v-if="coursePaper.StatusID == 2" class="mr30">{{
                coursePaper.IsPass == true ? "合格" : "不合格"
              }}</span>
            </p>
          </div>
        </div>
        <div class="coursePaper-right">
          <img src="@/assets/img/home/23.png" alt="" /> 考试
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Exam_Create } from "@/api/exam";
import { getToken } from '@/util/auth';
export default {
  name: "Chapter",
  props: {
    data: Object,
    chapterList: Array,
    coursePaper: Object,
    studyProgress: Number
  },
  data() {
    return {};
  },
  created() {
    this.list = this.chapterList.map((item, index) => {
      return { ...item, open: !index };
    });
  },
  methods: {
    isUnlocked(listData, index, chIndex) {
      let item = listData[index]
      let falg = false
      if (index == 0 && chIndex == 0) {
        falg = true
      }
      if (chIndex > 0 && item.Chapters[chIndex - 1].StudyProgress == 100) {
        falg = true
      }
      if (chIndex == 0 && index > 0 && listData[index - 1].Chapters && listData[index - 1].Chapters[listData[index - 1].Chapters.length - 1].StudyProgress == 100) {
        falg = true

      }
      return falg
    },

    toChapterDetail(item, list, index, chIndex) {
      if (!getToken()) {
        this.$store.state.LoginShow = true;
        return
      }
      if ((this.data.IsBuyed == true || this.data.Price == 0 || item.IsFree) && this.isUnlocked(list, index, chIndex)) {
        this.$router.push({
          path: "/chapterDetail",
          query: {
            CourseID: this.$route.query.CourseID,
            ChapterID: item.ChapterID,
          },
        });
      } else if (!this.isUnlocked(list, index, chIndex)) {
        this.$message({
          message: "请先学习前面的章节来解锁后续课程",
          type: "warning",
        });
      } else {
        this.$message({
          message: "该章节为付费章节，请购买后再学习",
          type: "warning",
        });
      }
    },
    toExam() {
      Exam_Create({
        FromType: 1,
        CourseID: this.$route.query.CourseID,
        PaperID: this.coursePaper.PaperID,
      }).then((res) => {
        this.$router.push({
          path: "/exam/detail",
          query: {
            FromType: 1,
            ExamID: res.data.ExamID,
            CourseID: this.$route.query.CourseID,
            PaperID: this.coursePaper.PaperID,
          },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chapterBox {
  border-radius: 10px;
  border: 1px solid #e9ecf0;

  li::after {
    display: none;
  }

  .Title {
    padding: 20px 40px;
    font-size: 20px;
    color: #333333;
    background: #f6f8fc;
  }

  .chapter-item {
    cursor: pointer;
    padding: 15px 40px;
    font-size: 18px;
    color: #666666;
    border-bottom: 1px solid #e9ecf0;

    &:last-child {
      border-bottom: none;
    }

    .flex1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .IsFreeImg {
      width: 22px;
      height: 19px;
    }

    .notFreeImg {
      width: 15px;
      height: 19px;
    }

    .ChapterName {
      margin: 0 20px;
    }

    .timeText {
      min-width: 20px;
    }

    .IsFree {
      width: 84px;
      padding: 5px 10px;
      background: #d5f3d0;
      border-radius: 6px;
      font-weight: 400;
      font-size: 16px;
      color: #32a500;
    }

    .time {
      display: flex;
      align-items: center;
      gap: 10px;

      .timeImg {
        display: inline-block;
        width: 18px;
        height: 18px;
        background: url("~@/assets/img/home/24.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    &:hover {
      color: #1d79ff;

      .ChapterName {
        color: #1d79ff;
        border-bottom: 1px solid #1d79ff;
      }

      .timeImg {
        display: inline-block;
        width: 18px;
        height: 18px;
        background: url("~@/assets/img/home/25.png") no-repeat;
        background-size: 100% 100%;
      }

      .timeText {
        color: #1d79ff;
        border-bottom: 1px solid #1d79ff;
      }
    }
  }
}

.coursePaper {
  height: 110px;
  background: #d0d4d8;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;

  .coursePaper-left {
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 16px;
    color: #333333;

    img {
      width: 53px;
      height: 53px;
    }

    .PaperName {
      margin-top: -10px;
      font-size: 20px;
      color: #999999;
    }

    .PaperContent {
      margin-top: 5px;
      font-size: 16px;
      color: #999999;
    }
  }

  .coursePaper-right {
    cursor: pointer;
    color: #999999;
    font-size: 16px;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.ISOK {
  background: #ffffff;
  border: 1px solid #e9ecf0;

  &:hover {
    background: #f5f5f5;
  }

  .PaperName {
    font-size: 20px !important;
    color: #333333 !important;
  }

  .PaperContent,
  .coursePaper-right {
    font-size: 16px;
    color: #666666;
  }

  .coursePaper-right {
    cursor: pointer;
    width: 100px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #1d79ff;
  }
}
</style>
